// Admin help-desk endpoints (ROLE_ADMIN), backed by /api/v1/support.

export const getAllTicketsURL = ({
	status,
	category,
	page = 0,
	size = 20,
}: {
	status?: string;
	category?: string;
	page?: number;
	size?: number;
}) => {
	const q = new URLSearchParams();
	if (status) q.set("status", status);
	if (category) q.set("category", category);
	q.set("page", String(page));
	q.set("size", String(size));
	return { url: `/support/admin/tickets?${q.toString()}`, method: "GET" };
};

export const getTicketURL = (id: string) => ({
	url: `/support/tickets/${id}`,
	method: "GET",
});

// Resolved order/return/product/customer/merchant context for a ticket.
export const getTicketContextURL = (id: string) => ({
	url: `/support/tickets/${id}/context`,
	method: "GET",
});

export const replyTicketURL = (id: string, message: string) => ({
	url: `/support/tickets/${id}/reply`,
	method: "POST",
	data: { message },
});

export const updateTicketStatusURL = (id: string, status: string) => ({
	url: `/support/admin/tickets/${id}/status`,
	method: "PATCH",
	data: { status },
});

export const assignTicketURL = (id: string, assigneeId: string) => ({
	url: `/support/admin/tickets/${id}/assign`,
	method: "PATCH",
	data: { assigneeId },
});

// Courier timeline of the order / return a ticket is about.
export const trackShipmentURL = (subOrderId: string) => ({
	url: `/orders/track/shipment/${subOrderId}`,
	method: "GET",
});
export const trackReturnURL = (returnItemQueueId: string) => ({
	url: `/orders/track/return-shipment/${returnItemQueueId}`,
	method: "GET",
});
